import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";

function NCXFormSelect(props) {
    const fieldname = props?.field?.properties?.fieldname;
    const [localValue, setLocalValue] = useState('');

    const handleSelectChange = (e) => {
        setLocalValue(e.target.value);
        props?.handleInputChange(fieldname, e.target.value, props?.field);
    }

    const selectorValue = (option) => {
        if (option && option.value) {
            return option?.value
        } else {
            return option?.label
        }
    }

    return (
        <Box key={props?.field._id} sx={{ marginBottom: "16px" }}>
            <FormControl fullWidth disabled={props?.field?.properties?.readOnly}>
                <InputLabel>{props?.field?.properties?.label}</InputLabel>
                <Select 
                MenuProps={{
                    sx: {
                        minWidth: '0 !important'
                    }
                }} 
                value={localValue} variant="outlined" label={props?.field?.properties?.label} onChange={handleSelectChange}>
                    {
                        props?.field?.properties?.options.map(opt => <MenuItem key={selectorValue(opt)} value={selectorValue(opt)}>{opt?.label}</MenuItem>)
                    }
                </Select>
            </FormControl>
        </Box>
    )
}

export default NCXFormSelect;